import MapButton from 'components/buttons/MapButton';
import BoundaryIcon from 'components/icons/BoundaryIcon';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ToggleBoundaryButton: FunctionComponent<Props> = ({
    className = '',
    isActive = true,
    onClick,
    testId = TEST_ID
}) => {
    const inactiveClass = isActive ? '' : styles.inactive;

    return (
        <MapButton className={`${inactiveClass} ${className}`} onClick={onClick} testId={testId}>
            <BoundaryIcon />
        </MapButton>
    );
};

export default ToggleBoundaryButton;
